import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { FaExclamationCircle, FaExclamationTriangle } from "react-icons/fa";
import './style.css';

const MsgDialog3 = (props: {Show: boolean, Title: string, Icon: string, Message: string, 
                  BtnOkName: string, BtnNokName: string, 
                  HandlerClickOk: any, HanlerdClickNok: any, Detalle?: string[]}) => {
                       
 return (
      <div>
        <Modal show={props.Show} centered={true} size='lg' >
            <Modal.Header  >
                <Modal.Title className='h3 text-center'>
                    {                        
                        props.Title
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-row gap-4 justify-content-center align-middle'>
                    <div >{props.Icon === "warning"
                        ? <FaExclamationTriangle className='text-warning' style={{fontSize:"5rem"}}/>
                        : <FaExclamationCircle className='text-success' style={{fontSize:"5rem"}}/>}</div>
                    {props.Detalle && props.Detalle.length > 0 ? (
                        <div className='d-flex flex-column justify-content-center'>
                            <div className='h5' dangerouslySetInnerHTML={{__html: props.Message}}></div>
                            <ul className='mb-0'>
                                {props.Detalle.map((linea: string, index: number) => <li key={index}>{linea}</li>)}
                            </ul>
                        </div>
                    ) : (
                        <div className='d-flex align-items-center h5' dangerouslySetInnerHTML={{__html: props.Message}}></div>
                    )}
                </div>
            </Modal.Body>                
            <Modal.Footer className=''>
                {
                    (props.BtnOkName) 
                        ? 
                        <Button type="button" className="btn btn-success btnColorOk" onClick={props.HandlerClickOk}>
                            {props.BtnOkName}
                        </Button>
                        : <div></div>
                }      
                {
                    (props.BtnNokName) 
                        ? 
                        <Button type="button" className="btn btn-danger btnColorNOk" onClick={props.HanlerdClickNok}>
                            {props.BtnNokName}
                        </Button>
                        : <div></div>
                }                                      
            </Modal.Footer>
        </Modal>
      </div>
  );
}

export default MsgDialog3;
